<template>
  <BaseAction>
    <ResendInvitationDialog
      v-if="isDialogOpen"
      @close="isDialogOpen = false"
      :user="user"
    />
    <PrimaryButton
      @click.native.stop="isDialogOpen = true"
      text
      class="resend-button"
    >
      {{ title }}
      <v-icon class="ml-2">
        mdi-send
      </v-icon>
    </PrimaryButton>
  </BaseAction>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ResendInvitationDialog from "@/views/settings/Users/dialogs/ResendInvitationDialog";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "ResendInvitation",
  components: { ResendInvitationDialog, PrimaryButton, BaseAction },
  props: {
    user: {
      type: Object,
      required: true
    },
    title: String
  },
  data() {
    return {
      isDialogOpen: false
    };
  }
};
</script>

<style lang="scss">
button.base-button.base-primary-button.v-btn.v-btn--flat.v-btn--text.primary--text.resend-button {
  padding: 0px 5px !important;
}
</style>
